import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as inventory from './InventoryRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({inventory: state.inventory})
const connector = connect(mapState, inventory.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const InventoryInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(InventoryInit)
